import { createPortal } from "react-dom";
import { ToastContainer } from "react-toastify";

import { TOAST_CONTAINER_PROPS } from "@configs";

import type { ToastContainerProps } from "react-toastify";

export function ToastPortal({ rtl, ...restProps }: ToastContainerProps) {
  const container = document.querySelector("#toastRoot");

  if (!container) return null;

  return createPortal(
    <ToastContainer {...TOAST_CONTAINER_PROPS} rtl={rtl} {...restProps} />,
    container,
  );
}
